<template>
    <v-layout justify-center>
        <v-responsive width="100%" height="100%">
            <list-heading title="오퍼월 접속 내역" v-model="showsSearch" showsFilterButton />

            <list-search-default
                v-bind="{
                    showsSearch,
                    loading,
                    searchKeys,
                }"
                v-on="{ search }"
            />

            <v-row class="ma-n2 mt-n1">
                <v-spacer />
                <v-col class="pa-2" cols="auto">
                    <list-excel v-slot="{ attrs, on }" v-on="{ excel }">
                        <v-card outlined style="overflow: hidden;">
                            <v-btn color="white" elevation="0" class="text-caption green--text" style="margin:-1px" v-bind="{ ...attrs, loading }" v-on="on">
                                <v-icon> mdi-microsoft-excel </v-icon>
                                <span> 엑셀다운로드 </span>
                            </v-btn>
                        </v-card>
                    </list-excel>
                </v-col>
                <v-col class="pa-2" cols="12">
                    <v-data-table v-bind="{ loading, headers, items }" disable-sort disable-pagination hide-default-footer class="v-sheet--outlined" :items-per-page="-1" ref="data-table">
                        <template v-for="(header, index) in headers.filter((header) => header.hasOwnProperty('formatter'))" #[`item.${header.value}`]="{ value, item }"> <span :key="index" :title="header.withTitle ? header.formatter.bind(item)(value, item) : undefined" v-html="header.formatter.bind(item)(value, item)" /> </template>

                        <template #footer>
                            <v-divider />
                            <v-pagination :value="page" :length="pageCount" :total-visible="11" color="primary" class="my-2" @input="(page) => $router.push({ query: { ...$route.query, page } })" />
                        </template>
                    </v-data-table>
                </v-col>
            </v-row>
        </v-responsive>
    </v-layout>
</template>

<script>
import api from "@/api";
import { initDataTableHeaders } from "@/assets/lib";

import ListExcel from "@/components/console/dumb/list-excel.vue";
import ListHeading from "@/components/console/dumb/list-heading.vue";
import ListSearchDefault from "@/components/console/dumb/list-search-default.vue";

const headers = initDataTableHeaders([
    { text: "순번", value: "index", width: 100, align: "end", formatterType: "number" },
    { text: "접속일시", value: "createdAt", formatterType: "datetime", width: 180 },
    { text: "사용자 (ID/이름)", value: "user", width: 240, formatter: ({ username, name } = {}) => `${username} / ${name}` },
    { text: "appcode", value: "appcode", width: 120 },
    { text: "app_uid", value: "app_uid", width: 220 },
    { text: "adid", value: "adid", width: 380 },
    { text: "idfa", value: "idfa", width: 380 },
]);

const searchKeys = [
    { text: "사용자", value: "_user" },
    { text: "appcode", value: "appcode" },
    { text: "app_uid", value: "app_uid" },
    { text: "adid", value: "adid" },
    { text: "idfa", value: "idfa" },
];

export default {
    components: {
        ListExcel,
        ListHeading,
        ListSearchDefault,
    },
    data: () => ({
        logs: [],

        limit: 20,
        summary: { totalCount: 0 },

        headers,
        searchKeys,

        loading: false,
        showsSearch: true,
    }),
    computed: {
        items() {
            return this.logs.map((item, index) => ({
                ...item,
                index: this.summary.totalCount - index - this.skip,
            }));
        },
        page() {
            return +(this.$route.query.page || "1");
        },
        skip() {
            return (this.page - 1) * this.limit;
        },
        pageCount() {
            return Math.ceil(this.summary.totalCount / this.limit) || 1;
        },
        params() {
            let { ...query } = this.$route.query;

            delete query.page;

            return { ...query };
        },
    },
    methods: {
        async init() {
            this.logs = [];
            this.summary = { totalCount: 0 };
            this.loading = false;

            await this.search();
        },

        async search() {
            if (this.loading) return;
            else this.loading = true;
            try {
                let { skip, limit, params } = this;
                let { summary, logs } = await api.console.greenp.offerwall.logs.gets({
                    headers: { skip, limit },
                    params,
                });

                this.summary = summary;
                this.logs = logs;
            } finally {
                this.loading = false;
            }
        },

        async excel({ skip = 0, limit = 0 } = {}) {
            if (this.loading) return;
            else this.loading = true;

            try {
                let { params } = this;
                let { logs } = await api.console.greenp.offerwall.logs.gets({
                    headers: { skip, limit },
                    params,
                });

                let { headers } = this;
                let fileName = "오퍼월_접속_내역";
                this.$excel(logs, headers, fileName);
            } finally {
                this.loading = false;
            }
        },
    },
    watch: {
        params() {
            this.search();
        },
    },
    mounted() {
        this.init();
    },
};
</script>

<style lang="scss" scoped>
::v-deep {
    .line-height-1-5 {
        line-height: 1.5;
    }
    .max-width-0 {
        max-width: 0;
    }
    .word-break-keep-all {
        word-break: keep-all;
    }
    .white-space-pre-line {
        white-space: pre-line;
    }
    .cursor-pointer {
        cursor: pointer;
    }
    .v-pagination button {
        box-shadow: none !important;
        border: thin solid rgba(0, 0, 0, 0.12);
    }
    .v-small-dialog__activator {
        height: 100%;
    }
    .v-small-dialog__activator__content {
        width: 100%;
    }

    th:first-of-type:not(:last-of-type),
    td:first-of-type:not(:last-of-type) {
        border-right: thin solid rgba(0, 0, 0, 0.12);
    }

    .v-data-table__expanded__content {
        box-shadow: none !important;
    }
    .vertical-align-top {
        vertical-align: top !important;
    }
    .vertical-align-middle {
        vertical-align: middle !important;
    }
}
</style>
